@if (commonService.isGenericFlowActive()) {
  <app-generic-home></app-generic-home>
} @else {
  <app-education-home></app-education-home>
}
